import React from 'react'
import './Technology.css'
import rjs from '../../../../assets/img/react_native.webp'
import angular from '../../../../assets/img/angular.webp'
import vue from '../../../../assets/img/vuejs.webp'
import node from '../../../../assets/img/nodejs.webp'
import php from '../../../../assets/img/php.webp'
import net from '../../../../assets/img/dotnet.webp'
import python from '../../../../assets/img/python.webp'
import java from '../../../../assets/img/java.webp'
import swift from '../../../../assets/img/swift.webp'
import objc from '../../../../assets/img/objc.webp'
import kotlin from '../../../../assets/img/kotlin.webp'
import flutter from '../../../../assets/img/flutter.webp'

function Technology() {

    const forntend = [
        {
            img: rjs,
            title: "React JS"
        },
        {
            img: angular,
            title: "Angular"
        },
        {
            img: vue,
            title: "Vue JS"
        }
    ]

    const backend = [
        {
            img:node,
            title: "Node JS"
        },
        {
            img:php,
            title: "Php"
        },
        {
            img:net,
            title: ".Net"
        },
        {
            img:python,
            title: "Python"
        },
        {
            img:java,
            title: "Java"
        }
    ]

    const native = [
        {
            img:swift,
            title: "Swift"
        },
        {
            img:objc,
            title: "objC"
        },
        {
            img:kotlin,
            title: "Kotlin"
        }
    ]

    const hybrid = [
        {
            img:flutter,
            title: "Flutter"
        },
        {
            img:rjs,
            title: "React Native"
        }
    ]
  return (
    <section className='tech-sec'>
        <div className='container'>
            <div className='head-ing' data-content='Technology'>Technology</div> 
            <div className='mn-head'> 
                <h5>Technology Stack</h5>
                <h3>Powering your growth</h3>
            </div>
            <h4>Web Development</h4>
            <h5>Frontend</h5>
            <ul>
                {
                    forntend.map((Technology, index)=>(
                        <li key={index}><div className='tech-icon'><img src={Technology.img} alt={Technology.title} loading="lazy"/></div>{Technology.title}</li>     
                    ))
                }
            </ul>
            <h5>Backend</h5>
            <ul>
                {
                   backend.map((Technology, index)=>(
                    <li key={index}><div className='tech-icon'><img src={Technology.img} alt={Technology.title} loading="lazy"/></div>{Technology.title}</li>
                   )) 
                }

            </ul>
            <h4 style={{marginTop:"40px"}}>Mobile Development</h4>
            <h5>Native</h5>
            <ul>
              {
                native.map((Technology, index)=>(
                    <li key={index}><div className='tech-icon'><img src={Technology.img} alt={Technology.title} loading="lazy"/></div>{Technology.title}</li> 
                ))
              }
            </ul>  
            <h5>Hybrid</h5>
            <ul>
              {
                hybrid.map((Technology, index)=>(
                    <li key={index}><div className='tech-icon'><img src={Technology.img} alt={Technology.title} loading="lazy"/></div>{Technology.title}</li> 
                ))
              }
            </ul>  
        </div>
    </section>
  )
}

export default Technology
